import { AnimatePresence, motion } from 'framer-motion'

export default function Transition(props) {
    return (
        <AnimatePresence initial={true}>
            <div className={props.className}>
                <motion.div
                    className="full"
                    key={props.transitionKey}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ type: "linear", duration: 0.5 }}
                >
                    {props.children}
                </motion.div>
            </div>
        </AnimatePresence>
    )
}